import React, {useContext} from 'react';
import './Notifications.less';
import {PseudoPagePopup} from "dialog-layout/pseudo-page-popup/PseudoPagePopup";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {Consent} from "compositions/consent/Consent";
import {ConsentText} from "elements/consent-text/ConsentText";

export const NOTIFICATIONS_POPUP = 'NOTIFICATIONS_POPUP';

//TODO push consent when pushes are implemented

export const Notifications = ({allowEmail, allowSms, onEmailClick, onSmsClick, onOverlayClick}) => {
	const translations = useContext(TranslationsContext);

	return <PseudoPagePopup
		title={getSafeTranslation('NotificationsPopup.title', translations)}
		description={getSafeTranslation('NotificationsPopup.description', translations)}
		onBackClick={onOverlayClick}
	>
		<div className="notifications">
			<div className="notifications__email-consent" onClick={() => onEmailClick(!allowEmail)}>
				<Consent
					isChecked={allowEmail}
					caption={
						<ConsentText
							text={getSafeTranslation('NotificationsPopup.emailMarketingConsentCheckboxCaption', translations)}
						/>}
				/>

			</div>
			<div className="notifications__sms-consent" onClick={() => onSmsClick(!allowSms)}>
				<Consent
					isChecked={allowSms}
					caption={
						<ConsentText
							text={getSafeTranslation('NotificationsPopup.smsMarketingConsentCheckboxCaption', translations)}
						/>
					}
				/>
			</div>
		</div>
	</PseudoPagePopup>
}
